import { render, staticRenderFns } from "./AgendaEvent.vue?vue&type=template&id=f8fcb47e&scoped=true"
import script from "./AgendaEvent.vue?vue&type=script&lang=js"
export * from "./AgendaEvent.vue?vue&type=script&lang=js"
import style0 from "./AgendaEvent.vue?vue&type=style&index=0&id=f8fcb47e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fcb47e",
  null
  
)

export default component.exports